import $ from "jquery"

$('.js-techs-item').each(function(){
    $(this).on('click', function(){
        const techsContentBase = $(this).closest('.techs__choices-item').find('.js-techs-content-base').html();
        const techsSvgBase = $(this).closest('.techs__choices-item').find('.js-techs-svg-base').html();
        
        $('.js-techs-svg').html(techsSvgBase);
        $('.js-techs-content').html(techsContentBase);
        $('.techs__choices-item').removeClass('active');
        $(this).closest('.techs__choices-item').addClass('active');
    });
});